export const isXPM = () => window.self !== window.top;
